import { areaListAllWithChildren } from '@/api/common';

const state = {
  areaList: [], // 地址列表
};
const actions = {
  initAddressConfig({ commit }, payload = true) {
    return new Promise((resolve, reject) => {
      areaListAllWithChildren(payload).then(res => {
        const { success, data } = res;
        let areaList = [];
        if (success && data?.length > 0) {
          areaList = [...data.slice(1), data[0]];
          commit('$uStore', {
            name: 'address.areaList',
            value: areaList,
          });
        }
        resolve(areaList);
      }).catch((err) => {
        reject(err);
      });
    });
  },
};
export default {
  state,
  actions,
};
